export default function Cardoor({ ...rest }: React.SVGProps<any>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      type="image/svg+xml"
      viewBox="0 0 492 492"
      {...rest}
    >
      <path
        d="M367.113 431.06h-75.174c-18.982 0-37.435-3.834-54.846-11.396a137.429 137.429 0 0 1-37.32-24.005 137.447 137.447 0 0 1-27.746-34.63L82.33 202.022a64.86 64.86 0 0 1-8.353-31.807 64.816 64.816 0 0 1 15.299-41.794 64.815 64.815 0 0 1 38.665-22.04l258.158-43.57a27.76 27.76 0 0 1 22.587 6.186 27.763 27.763 0 0 1 9.858 21.243v289.39c0 13.738-5.35 26.653-15.064 36.367-9.714 9.713-22.63 15.063-36.367 15.063zm23.626-357.119c-.905 0-1.815.075-2.723.229l-258.158 43.571a53.068 53.068 0 0 0-44.36 52.474 53.324 53.324 0 0 0 6.866 26.147l89.697 159.006c13.411 23.774 34.585 42.855 59.621 53.729 15.954 6.929 32.863 10.443 50.256 10.443h75.174c22.007 0 39.911-17.904 39.911-39.911V90.239c0-4.806-2.105-9.342-5.775-12.445a16.258 16.258 0 0 0-10.509-3.853z"
        style={{
          fillRule: "evenodd",
          clipRule: "evenodd",
          fill: "#212121",
        }}
      />
      <path
        d="M389.983 194.977H107.897a5.76 5.76 0 0 1-5.018-2.932l-.691-1.226a42.01 42.01 0 0 1-5.41-20.603c0-9.898 3.52-19.513 9.909-27.075a42 42 0 0 1 25.047-14.278l257.291-43.424a5.76 5.76 0 0 1 6.719 5.68v98.098a5.762 5.762 0 0 1-5.761 5.76zm-278.652-11.52h272.891V97.932l-250.57 42.29a30.465 30.465 0 0 0-18.167 10.356 30.463 30.463 0 0 0-7.188 19.638 30.5 30.5 0 0 0 3.034 13.241zM188.627 230.634h-47.409a5.76 5.76 0 0 1 0-11.52h47.409a5.76 5.76 0 0 1 0 11.52z"
        style={{
          fillRule: "evenodd",
          clipRule: "evenodd",
          fill: "#212121",
        }}
      />
    </svg>
  )
}
